import { useState } from "react";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../firebase";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import logo from "../assets/logo.png";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleReset = async (e) => {
    e.preventDefault();
    try {
      await sendPasswordResetEmail(auth, email);
      setMessage("Password reset link sent to your email!");
      setError("");
    } catch (err) {
      setError("No user found with that email.");
      setMessage("");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#050A1F] to-[#0B112E] text-white">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="bg-white/10 backdrop-blur-xl border border-white/20 rounded-2xl p-10 w-full max-w-md shadow-2xl"
      >
        <div className="flex flex-col items-center mb-6">
          <img src={logo} alt="Vidra Logo" className="w-50 h-50 mb-3" />
          <h2 className="text-3xl font-bold bg-gradient-to-r from-cyan-400 to-purple-500 bg-clip-text text-transparent">
            Reset Password
          </h2>
        </div>
        <form onSubmit={handleReset} className="space-y-5">
          <input
            type="email"
            placeholder="Enter your email"
            className="w-full bg-white/10 border border-white/20 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-cyan-500"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <button
            type="submit"
            className="w-full bg-gradient-to-r from-cyan-500 to-purple-600 py-3 rounded-lg font-semibold hover:scale-105 transition-transform"
          >
            Send Reset Link
          </button>
        </form>
        {message && <p className="text-green-400 text-sm text-center mt-3">{message}</p>}
        {error && <p className="text-red-400 text-sm text-center mt-3">{error}</p>}
        <p className="text-center text-sm mt-6 text-gray-300">
          <Link to="/login" className="text-cyan-400 hover:underline">
            Back to Login
          </Link>
        </p>
      </motion.div>
    </div>
  );
}
